<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="sensorAssociations-modal">
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Sensor Associations</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
    </div>

    <div class="modal-body" style="padding: 0px;">
        <p-table #sensorDataTable [columns]="sensorAssociationsCols" [value]="sensorsAssociations" [scrollable]="true" scrollHeight="553px">
            <ng-template let-columns pTemplate="header">
                <tr style="height: 35px; margin-top: 1px;">
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-rowData ; pTemplate="body">
                <tr style="height: 35px;">
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.sensor.name }}
                    </td>
                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.sensor.uuid }}
                    </td>
                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        <div *ngFor="let sensorGroup of rowData.sensorGroups">
                            {{ sensorGroup.name }}
                        </div>
                    </td>
                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        <div *ngFor="let device of rowData.devices">
                            {{ device.name }}
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
